// extracted by mini-css-extract-plugin
export default {"homeRectangleAd":"HomePage_homeRectangleAd__pAAaV","homeRectangleAdImage":"HomePage_homeRectangleAdImage__fPt08"};